export const moduleName = 'setPassword'
